export { RegPlateIcon } from './reg-plate'
